export default (axios) => ({
  getProduct() {
    return axios.get('/productDetail/getTree')
  },
  // 获取国家
  getCountry(lang) {
    return axios.get(`/country/${lang}`)
  },
  // 获取城市
  getCity(params) {
    return axios({
      url: '/city/en',
      params,
      method: 'get'
    })
  },
  // 经销商留资
  submitDealerForm(data) {
    return axios.post('/leaveMessageDealer/add', {
      data
    })
  },
  // baseinfo 留资
  toSubmitForm(data) {
    return axios.post('/leaveMessageRequest/add', {
      data
    })
  },
  // 支持中心表单提交
  messageFeedback(data) {
    return axios.post('/messageFeedback/add', {
      data
    })
  }
})
